export const GET_ABOUT_ME = 'GET_ABOUT_ME';
export const GET_EXPERIENCE = 'GET_EXPERIENCE';
export const GET_EDUCATION = 'GET_EDUCATION';
export const GET_SKILLS = 'GET_SKILLS';

export const getAboutMe = aboutMe => ({
  type: GET_ABOUT_ME,
  payload: aboutMe,
});

export const getExperince = experiences => ({
  type: GET_EXPERIENCE,
  payload: experiences,
});

export const getEducation = educations => ({
  type: GET_EDUCATION,
  payload: educations,
});

export const getSkills = skills => ({
  type: GET_SKILLS,
  payload: skills,
});
